import { render, staticRenderFns } from "./EmailDivider.vue?vue&type=template&id=105b8641"
import script from "./EmailDivider.vue?vue&type=script&lang=js"
export * from "./EmailDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports